export default __webpack_public_path__ + "static/media/wifi6e-Photoroom.a898992e.png";